<script>
    import FancyButton from './FancyButton.svelte';
</script>


<FancyButton label="Play as an HR Manager" image={"/hrmanager.svg"}/>